import { CustomKeyAttributes } from '@loyalty/shared-common/profile-api-client';
import { Fields } from '@react-awesome-query-builder/core';
import { RequiredProps } from '@loyalty/shared-common';
import { BaseConfigSettings } from '../fields';
import { profileFields } from './profile-fields';

export function qualifioLoyaltyLevelChange(
  settings: BaseConfigSettings,
  customKeys?: CustomKeyAttributes[],
): Fields {
  const { t } = settings;
  return {
    event: {
      label: t('rule.criteria.event'),
      type: '!group',
      subfields: {
        timestamp: {
          label: t('rule.criteria.date'),
          type: 'date',
          preferWidgets: ['date'],
        },
      },
    },
    profile: {
      label: t('rule.criteria.profile'),
      type: '!group',
      subfields: profileFields(settings, customKeys),
    },
  };
}
